import { Controller } from "@hotwired/stimulus";
import { showModelingLoading } from "../scenario_modeling/payload_refresh";
import { appendModelingControlParams } from "../scenario_modeling/request_params";

export default class extends Controller {
  static targets = ["unitToggle", "unitDisplayInput"];

  static values = {
    unitDisplay: { type: String, default: "buyer" },
    modellingUrl: String,
  };

  connect() {
    this._syncUnitToggles();
    this._fetchInFlight = false;
  }

  selectUnit(event) {
    const value = event.currentTarget.dataset.unitDisplay;
    if (!value || value === this.unitDisplayValue || this._fetchInFlight) return;

    this.unitDisplayValue = value;
    this._syncUnitToggles();
    this._reloadWithControls();
  }

  _reloadWithControls() {
    if (!this.modellingUrlValue) {
      window.location.reload();
      return;
    }

    this._fetchInFlight = true;
    this._setUnitTogglesDisabled(true);
    showModelingLoading();

    const url = new URL(this.modellingUrlValue, window.location.origin);
    const params = new URLSearchParams();
    appendModelingControlParams(params);
    url.search = params.toString();

    window.location.assign(url.toString());
  }

  _syncUnitToggles() {
    this.unitToggleTargets.forEach((button) => {
      const active = button.dataset.unitDisplay === this.unitDisplayValue;
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });

    if (this.hasUnitDisplayInputTarget) {
      this.unitDisplayInputTarget.value = this.unitDisplayValue;
    }
  }

  _setUnitTogglesDisabled(disabled) {
    this.unitToggleTargets.forEach((button) => {
      button.disabled = disabled;
    });
  }
}
